import { Box, Button, Chip, LinearProgress, Stack, Typography, useMediaQuery } from '@mui/material'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import { useContext } from 'react'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import { colorPalette } from '~/constants/styles/colors'
import { theme } from '~/lib/theme'
import { StartGuideButton } from '~/components/common/StartGuideButton'

export const CreateCampaignHeader = (props: { title?: string; onBack: () => void; isNew?: boolean }) => {
  const { progress } = useContext(CreateCampaignContext)
  const { title, isNew, onBack } = props
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <Stack mb={5}>
      <Stack
        pt={3}
        pb={isMobile ? 0 : 3}
        mb={isMobile ? 3 : 5}
        borderBottom={isMobile ? 0 : 1}
        borderColor={colorPalette.other.outlineBorder}
      >
        <Stack
          direction="row"
          gap={2}
          justifyContent="space-between"
          alignItems="center"
          width={isMobile ? '100%' : '50vw'}
          mx="auto"
        >
          <Button size="large" variant="text" onClick={onBack}>
            <KeyboardArrowLeft />
            戻る
          </Button>
          {isMobile ? (
            <Box display="flex" justifyContent="center">
              {title && (
                <Typography variant="headingS" fontWeight="bold">
                  {title.replace('に関する情報について教えてください', '')}
                </Typography>
              )}
            </Box>
          ) : (
            <LinearProgress variant="determinate" value={progress} valueBuffer={100} sx={{ flexGrow: 1 }} />
          )}

          <Button
            variant="text"
            size="large"
            type="submit"
            disabled={progress === 100}
            sx={{
              '&.Mui-disabled': {
                backgroundColor: 'transparent',
              },
            }}
          >
            次へ
            <KeyboardArrowRight />
          </Button>
        </Stack>
      </Stack>
      {!isMobile ? (
        <Stack direction="row" gap={1} alignItems="center" justifyContent="center">
          {isNew === true && <Chip variant="outlined" label={'New'} color="primary" size="small" />}
          {title && (
            <Typography variant="headingL" fontWeight="bold">
              {title}
            </Typography>
          )}
        </Stack>
      ) : (
        <LinearProgress variant="determinate" value={progress} valueBuffer={100} sx={{ flexGrow: 1 }} />
      )}
      {isMobile && (
        <Box sx={{ ml: 'auto', mt: 3, mr: 2.5 }}>
          <StartGuideButton variant="outlined" fixedPositionBottomRight />
        </Box>
      )}
    </Stack>
  )
}
